import Home from './reducers';

import HomePage from './components/Home';

import {
  PRIVACY_POLICY_PATH,
  TERMS_OF_SERVICE_PATH,
} from '../../constants/routes';
import PrivacyPolicyPage from '../../pages/PrivacyPolicy';
import TermsOfServicePage from '../../pages/TermsOfService';

const Routes = [
  {
    index: true,
    Component: HomePage,
  },
  {
    path: TERMS_OF_SERVICE_PATH,
    Component: TermsOfServicePage,
  },
  {
    path: PRIVACY_POLICY_PATH,
    Component: PrivacyPolicyPage,
  },
];

const Reducers = {
  Home,
};

export default {
  Reducers,
  Routes,
};
